import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import useOrderListing from "./useOrderListing";
import EmptyData from "../../../Global/EmptyData";
import OrderColumn from "../../../Global/OrderColumn";

const OrderListing = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    orderListingList,
    paginationOptions,
    orderListingState,
    handleEditColumnsClick,
    updateOrderListingFields,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useOrderListing();

  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={orderListingState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: orderListingState?.search }}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
        />
        {orderListingList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={orderListingList?.data?.result || []}
            uniqueID={"id"}
            fields={orderListingList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={orderListingState?.clearSelection}
            perpage={orderListingState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={orderListingList?.data?.fields || []}
              moduleId={orderListingList?.data?.module_id}
              updateData={updateOrderListingFields}
            />
          </div>
        </ModalLayout>

        {orderListingList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={orderListingState?.currentPage}
            totalPageCount={Math.ceil(
              orderListingList.data.total_count /
                orderListingState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === orderListingState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
      </div>
    </>
  );
};

export default OrderListing;
